module.exports = __webpack_public_path__ + "img/icon-tbbd.dd02ffa1.png";